/**
 * Calcula el color de texto apropiado (blanco o negro) basado en el color de fondo
 * @param {string} hexColor - Color hexadecimal (ej: '#ff0000' o 'ff0000')
 * @returns {string} - 'white' o 'black'
 */
export const getContrastTextColor = (hexColor) => {
  if (!hexColor) return 'black';
  
  // Remover el # si existe
  const hex = hexColor.replace('#', '');
  
  // Convertir a RGB
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  
  // Calcular luminancia usando la fórmula estándar
  const luminance = (r * 0.299 + g * 0.587 + b * 0.114) / 255;
  
  // Retornar blanco para colores oscuros, negro para colores claros
  return luminance > 0.5 ? 'black' : 'white';
};